import TooltipContainer from '~/components/TooltipContainer'
import ChartShow from '../show/ChartShow'
import { useChartEditContext } from './ChartEditContext'
import ChartEditControls from './ChartEditControls'
import TopInputs from './TopInputs'
import ChartChordInputs from './ChartChordInputs'
import ChartLyricsInput from './ChartLyricsInput'
import ChartSubmitButtons from './ChartSubmitButtons'
import { getLcn } from '~/utils/labeled-classnames'


export default function ChartEditUi() {
  const { chart, editedChart } = useChartEditContext()
  const isNewChart = !chart.id
  const isPersistedChart = !!chart.id

  const lcn = getLcn({
    chartEditComponent: 'flex flex-col gap-5'
  });


  return (
    <div className={lcn.chartEditComponent}>
      <div className="chart-title flex items-baseline gap-2">
        <h1>
          Chart Id #{chart.id}
        </h1>
      </div>
      <div className='chart-edit'>
        <div className="flex flex-col gap-2">
          <TopInputs />
          {isNewChart ? (
            <ChartSubmitButtons />
          ) : (
            <>
              <ChartEditControls />
              <div className="flex flex-col md:flex-row gap-2">
                <div className='edit-chords w-full md:w-2/3'>
                  <ChartChordInputs />
                  <ChartSubmitButtons />
                </div>
                <div id='edit-lyrics' className="w-full md:w-1/3">
                  <ChartLyricsInput />
                  <ChartSubmitButtons />
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {isPersistedChart &&
        <ChartShow chart={editedChart} />
      }

    </div>
  )
}
